import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import CabinType from './CabinType';
import GenderInclusiveHousing from './GenderInclusiveHousing';
import Roommate from './Roommate';
import PermissionSplash from 'components/PermissionSplash';

export default class Cabin extends React.Component {
	render() {
		let routeProps = this.props;
		const read = this.props.userRole !== undefined ? this.props.userRole.some(role => {
			return (role.section === 'Cabin' && role.access_read === "1")
		}) : false
	if ((this.props.variant === 'admin' && read === true) || this.props.variant !== 'admin') {
			return (
				<Switch>
					<Route path="/portal/cabin/Cabin Type Preferences" render={() => <CabinType {...routeProps} />} />
					<Route path="/portal/cabin/Gender Inclusive Housing Options" render={() => <GenderInclusiveHousing {...routeProps} />} />
					<Route path="/portal/cabin/Roommate Requests" render={() => <Roommate {...routeProps} />} />
					<Route path="*" render={() => (
						<Redirect to="/portal/cabin/Cabin Type Preferences" />
					)} />
				</Switch>
			);
		} else {
			return (

				<PermissionSplash />

			);
		}
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/Cabin/index.jsx